import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "amount",
    "deductionStartMonth",
    "numberOfDeductions",
    "schedulePreview",
    "scheduleBody",
    "monthlyAmount",
  ]

  connect() {
    this.updateSchedulePreview()
  }

  updateSchedulePreview() {
    const amount = parseFloat(this.amountTarget?.value) || 0
    const numberOfDeductions = parseInt(this.numberOfDeductionsTarget?.value) || 0
    const startMonthValue = this.deductionStartMonthTarget?.value

    if (amount <= 0 || numberOfDeductions <= 0 || !startMonthValue) {
      this.schedulePreviewTarget.classList.add("hidden")
      return
    }

    const startDate = this.parseMonthValue(startMonthValue)
    if (!startDate) {
      this.schedulePreviewTarget.classList.add("hidden")
      return
    }

    const baseAmount = Math.round((amount / numberOfDeductions) * 100) / 100
    const lastAmount =
      Math.round((amount - baseAmount * (numberOfDeductions - 1)) * 100) / 100

    // Update monthly amount display
    if (this.hasMonthlyAmountTarget) {
      this.monthlyAmountTarget.textContent = this.formatCurrency(baseAmount)
    }

    // Build schedule rows
    const rows = []
    for (let i = 0; i < numberOfDeductions; i++) {
      const month = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1)
      const deductionAmount = i === numberOfDeductions - 1 ? lastAmount : baseAmount
      rows.push(this.buildScheduleRow(month, deductionAmount, i + 1))
    }

    this.scheduleBodyTarget.innerHTML = rows.join("")
    this.schedulePreviewTarget.classList.remove("hidden")
  }

  parseMonthValue(value) {
    if (!value) return null

    // Handle "YYYY-MM" format
    const parts = value.split("-")
    if (parts.length >= 2) {
      const year = parseInt(parts[0])
      const month = parseInt(parts[1]) - 1
      if (!isNaN(year) && !isNaN(month)) {
        return new Date(year, month, 1)
      }
    }

    // Try parsing "DD/MM/YYYY" (from flatpickr alt format)
    const slashParts = value.split("/")
    if (slashParts.length === 3) {
      const year = parseInt(slashParts[2])
      const month = parseInt(slashParts[1]) - 1
      if (!isNaN(year) && !isNaN(month)) {
        return new Date(year, month, 1)
      }
    }

    return null
  }

  buildScheduleRow(date, amount, index) {
    const monthName = date.toLocaleDateString("fr-FR", {
      month: "long",
      year: "numeric",
    })
    const capitalizedMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1)

    return `
      <tr class="border-b border-gray-100 last:border-0">
        <td class="py-2 px-3 text-sm text-gray-500">${index}</td>
        <td class="py-2 px-3 text-sm font-medium text-gray-900">${capitalizedMonth}</td>
        <td class="py-2 px-3 text-sm text-right font-medium text-gray-900">${this.formatCurrency(amount)}</td>
      </tr>
    `
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount) + " F CFA"
  }
}
